import React from "react";

import styles from "./styles/Navbar.module.scss";

import { Image } from "react-bootstrap";
import { GiHamburgerMenu } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../Context/AppContext";

export default function Navbar({ handleToggle, isBack, isPermanentClose }) {
  const navigate = useNavigate();
  const { isWebView } = useAppContext()

  const handleBackButton = () => {
    if (!isWebView) return navigate(-1);

    if (!isPermanentClose) {
      navigate(-1)
    } else {
      if (window?.FlutterChannel) {
        window.FlutterChannel.postMessage("close");
      }
      else {
      }
    }
  }
  return (
    <div className={styles.Navbar}>
      <div className={styles.container}>
        <div className={styles.titleContainer}>
          {isBack && (
            <span onClick={handleBackButton} className={styles.toggleButton}>
              <img src="/assets/cross.png" />
              {/* <GiHamburgerMenu /> */}
            </span>
          )}

          <div className={styles.logoContainer}>
            <Image
              src="/logo.png"
              alt="Navbar-Logo-Large"
              className={`${styles.large} d-none d-lg-flex`}
            />
            <Image
              src="/logo.png"
              alt="Navbar-Logo-Small"
              className={`${styles.small} d-flex d-lg-none`}
            />
          </div>
        </div>
      </div>

      {/* <div className={styles.optionContainer}>
                {isSearchBar ?
                    <div className={styles.search}>
                        <div className={styles.searchButton}>
                            <AiOutlineSearch size={25} />
                        </div>
                        <input
                            type="text"
                            placeholder={dictionary.search}
                        />
                    </div>
                    : ''}
                <div className={styles.iconContainer} onClick={handleCartClick}>
                    <CartIcon />
                </div>
                <div className={styles.iconContainer} onClick={handleShowNotification}>
                    <NotificationIcon />
                </div>

                <div className={styles.profileButton}>
                    <img
                        src="/images/user.png"
                        alt="User Image"
                        className={styles.image}
                        onClick={handleShowProfile}
                    />
                </div>

            </div > */}
    </div>
  );
}
